module.exports = __webpack_public_path__ + "static/media/1.0be83102.png";